// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__bBvQ6","body":"style__body__QACHl","header":"style__header__MESaH","footer":"style__footer__bgueS"};